import { OrgOwnedModel } from "./BaseModel";

export interface RobotConfigTemplate extends OrgOwnedModel {
  version: string;
  type: string;
  yamlContent: string;
}

export function createRobotConfigTemplate(_id = ""): RobotConfigTemplate {
  return {
    _id,
    orgId: "",
    version: "",
    type: "",
    yamlContent: "",
  };
}